import axiosInstance from './axios_instance';

class HttpClient {
   async request(config: object, callbacks: {success: Function, failure: Function}){
      try{
         const response = await axiosInstance.request(config);
         callbacks.success(response);
      } catch (error){
         callbacks.failure(error);
      }
   }
   setAuthToken(token: string){
      axiosInstance.defaults.headers.common = {'Authorization': `Bearer ${token}`};
   }
   clearAuthToken(){
      axiosInstance.defaults.headers.common = {'Authorization': ''};
   }
   changeBaseUrlToProduction(){
      axiosInstance.defaults.baseURL = 'https://services-internal.classkick.com';
   }
}

const httpClient = new HttpClient();

export default httpClient;
